// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PremiumText-cls1___405e0fdda2c5aedf0dd{/*!*/}.PremiumText-cls2___d591c1e614fe8a07129{font-size:14px;font-weight:500;color:#0645b1;display:inline-flex;align-items:center}.PremiumText-cls2___d591c1e614fe8a07129:hover,.PremiumText-cls2___d591c1e614fe8a07129:active,.PremiumText-cls2___d591c1e614fe8a07129:visited{color:#0645b1;text-decoration:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "PremiumText-cls1___405e0fdda2c5aedf0dd",
	"cls2": "PremiumText-cls2___d591c1e614fe8a07129 PremiumText-cls1___405e0fdda2c5aedf0dd"
};
export default ___CSS_LOADER_EXPORT___;
